import { createContext } from 'react';

import { RmpcTattooShort, RmpcTattooDetailed, RmpcNestedDictionaryType } from '@/api/integrations/rmpc/types/types';
import { GeneralDictionaryType } from '@/api/types/common';

import type { TattooSearchFormData } from '../model/types';

export interface TattooSearchContextValue {
  categories: RmpcNestedDictionaryType[] | null;
  bodyLocations: RmpcNestedDictionaryType[] | null;
  page: number;
  searchParams: TattooSearchFormData | null;
  result: RmpcTattooShort[];
  total: number;
  tattooDetailsData: RmpcTattooDetailed | null;
  isLoading: boolean;
  isFetching: boolean;
  isDetailsLoading: boolean;
  isDictionariesLoading: boolean;
  hasBeenFetched: boolean;
  getContextDictionaries: () => Record<string, GeneralDictionaryType[]>;
  handleSearch: (data: TattooSearchFormData) => void;
  handlePageChange: (newPage: number) => void;
  handleDetails: (item: RmpcTattooShort) => void;
  handleModalClose: () => void;
  handleClear: () => void;
}

const defaultContextValue: TattooSearchContextValue = {
  categories: null,
  bodyLocations: null,
  page: 1,
  searchParams: null,
  result: [],
  total: 0,
  tattooDetailsData: null,
  isLoading: false,
  isFetching: false,
  isDetailsLoading: false,
  isDictionariesLoading: false,
  hasBeenFetched: false,
  getContextDictionaries: (): Record<string, GeneralDictionaryType[]> => ({}),
  handleSearch: () => {},
  handlePageChange: () => {},
  handleDetails: () => {},
  handleModalClose: () => {},
  handleClear: () => {},
};

export const TattooSearchContext = createContext<TattooSearchContextValue>(defaultContextValue);
